// import React, { useState, useEffect } from "react";

// const getReadableAddress = async (lat, lon) => {
//   try {
//     const response = await fetch(
//       `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
//     );
//     const data = await response.json();
//     const address = data.address;
//     const city = address.city || address.town || address.village || address.state || "";
//     const country = address.country || "";
//     return `${city}, ${country}`;
//   } catch (error) {
//     console.error("Error during reverse geocoding:", error);
//     return null;
//   }
// };

// const LocationProvider = ({ onLocationReady }) => {
//   const [location, setLocation] = useState(null); // { latitude, longitude }
//   const [address, setAddress] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const locationStr = localStorage.getItem("userLocation");

//       if (locationStr) {
//         const loc = JSON.parse(locationStr);
//         if (loc.latitude && loc.longitude) {
//           setLocation(loc);
//           const addr = await getReadableAddress(loc.latitude, loc.longitude);
//           setAddress(addr);
//           if (onLocationReady) onLocationReady(loc, addr);
//           return;
//         } else {
//           localStorage.removeItem("userLocation");
//         }
//       }

//       if ("geolocation" in navigator) {
//         navigator.geolocation.getCurrentPosition(
//           async (position) => {
//             const coords = {
//               latitude: position.coords.latitude,
//               longitude: position.coords.longitude,
//             };
//             localStorage.setItem("userLocation", JSON.stringify(coords));
//             setLocation(coords);
//             const addr = await getReadableAddress(coords.latitude, coords.longitude);
//             setAddress(addr);
//             if (onLocationReady) onLocationReady(coords, addr);
//           },
//           (err) => {
//             if (err.code === err.PERMISSION_DENIED) {
//               setError("Location permission denied.");
//             } else {
//               setError("Error fetching location.");
//             }
//           }
//         );
//       } else {
//         setError("Geolocation is not supported by this browser.");
//       }
//     };

//     fetchLocation();
//   }, [onLocationReady]);

//   return null; // This component does not render anything
// };

// export default LocationProvider;

import React, { useState, useEffect } from "react";

const getReadableAddress = async (lat, lon) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
    );
    const data = await response.json();
    const address = data.address;
    const city = address.city || address.town || address.village || address.state || "";
    const country = address.country || "";
    return `${city}, ${country}`;
  } catch (error) {
    console.error("Error during reverse geocoding:", error);
    return null;
  }
};

const LocationProvider = ({ onLocationReady }) => {
  const [hasLocationBeenHandled, setHasLocationBeenHandled] = useState(false);

  useEffect(() => {
    const fetchLocation = async () => {
      const stored = localStorage.getItem("userLocation");

      if (stored) {
        const loc = JSON.parse(stored);
        if (loc.latitude && loc.longitude) {
          if (!hasLocationBeenHandled) {
            const addr = await getReadableAddress(loc.latitude, loc.longitude);
            if (onLocationReady) {
              onLocationReady(loc, addr);
              setHasLocationBeenHandled(true);
            }
          }
          return;
        } else {
          localStorage.removeItem("userLocation");
        }
      }

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const coords = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            localStorage.setItem("userLocation", JSON.stringify(coords));

            const addr = await getReadableAddress(coords.latitude, coords.longitude);
            if (onLocationReady && !hasLocationBeenHandled) {
              onLocationReady(coords, addr);
              setHasLocationBeenHandled(true);
            }
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              console.warn("User denied location permission.");
            } else {
              console.error("Geolocation error:", error.message);
            }
          }
        );
      } else {
        console.warn("Geolocation not supported by browser.");
      }
    };

    fetchLocation();
  }, [onLocationReady, hasLocationBeenHandled]);

  return null;
};

export default LocationProvider;

